exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".text-display p.app-display{line-height:1.42857;padding:10px;font-size:14px;white-space:pre-line}.text-display h5{white-space:pre-line}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!./directives/freeforms/text_display/text_display.css
// module id = 404
// module chunks = 0